import BasicLayout from "@/layouts/basic-layout";
const meta = {
  auth: true
};
const pre = "content-center-";
export default {
  path: "/content-center",
  name: "content-center",
  redirect: {
    name: `${pre}contents`
  },
  meta,
  component: BasicLayout,
  children: [{
    path: "contents",
    name: `${pre}contents`,
    meta: {
      ...meta,
      title: "内容管理"
    },
    component: () => import("@/pages/content-center/contents/index.vue")
  }, {
    path: "contents/create",
    name: `${pre}contents-create`,
    meta: {
      ...meta,
      title: "新建内容"
    },
    component: () => import("@/pages/content-center/contents/edit.vue")
  }, {
    path: "contents/edit",
    name: `${pre}contents-edit`,
    meta: {
      ...meta,
      title: "编辑内容"
    },
    component: () => import("@/pages/content-center/contents/edit.vue")
  }, {
    path: "categories",
    name: `${pre}categories`,
    meta: {
      ...meta,
      title: "栏目分类"
    },
    component: () => import("@/pages/content-center/categories/index.vue")
  }, {
    path: "banners",
    name: `${pre}banners`,
    meta: {
      ...meta,
      title: "Banner管理"
    },
    component: () => import("@/pages/content-center/banners/index.vue")
  }]
};